// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { BunzlActionUnion } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { Draft } from "immer";

type RequestAQuoteState = ApplicationState["bunzl"]["components"]["requestAQuote"];

const initialState: RequestAQuoteState = {
    isLoading: false,
};

const actions = {
    "Bunzl/Components/RequestAQuote/BeginLoading": (draft: Draft<RequestAQuoteState>) => {
        draft.isLoading = true;
    },
    "Bunzl/Components/RequestAQuote/FinishLoading": (draft: Draft<RequestAQuoteState>) => {
        draft.isLoading = false;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type BunzlComponentsRequestAQuoteFormActions = BunzlActionUnion<typeof actions>;
export default reducer;
